import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import HeaderConfiguration from "../components/HeaderConfiguration";
import InputPortList from '../components/InputPortList';
import LimitSameValues from '../components/LimitSameValues';
import PanelLayout from "../components/PanelLayout";


class  BlenderPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Blender",
        };
        this.changeTab = this.changeTab.bind(this);
    }
    
    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }
    render() {       
        return (
            <PanelLayout
                headerTabs={<>
                        <span data-id="Blender" onClick={this.changeTab}
                              className={this.state.selectedTab === "Blender" ? "navigation-tab current" : "navigation-tab"}>Blender</span>
                        <span data-id="Settings" onClick={this.changeTab}
                              className={this.state.selectedTab === "Settings" ? "navigation-tab current" : "navigation-tab"}>Settings</span>
                    </>
                }
                customTabs
            >
                <div className={this.state.selectedTab === "Blender" ? "gui-editor-content active" : "gui-editor-content"}>
                    <HeaderConfiguration />
                    <InputPortList />
                </div>
                <div className={this.state.selectedTab === "Settings" ? "gui-editor-content active" : "gui-editor-content"}>
                    <LimitSameValues />
                </div>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {hideModal})(BlenderPanel);